import { t } from "i18next";

import { PartTypeSchema, PartTypeType } from "shared";

type Params = { type: PartTypeType | undefined | null };

type MaterialLabelSuffixKey = "MACHINING" | "SHEET" | "BAR" | "TUBE";

const getMaterialLabelSuffixKey = (
  type: PartTypeType | undefined | null,
): MaterialLabelSuffixKey | null => {
  switch (type) {
    case PartTypeSchema.enum.MACHINING:
      return "MACHINING";
    case PartTypeSchema.enum.SHEET:
      return "SHEET";
    case PartTypeSchema.enum.ROUND_BAR:
    case PartTypeSchema.enum.SQUARE_BAR:
      return "BAR";
    case PartTypeSchema.enum.ROUND_TUBE:
    case PartTypeSchema.enum.SQUARE_TUBE:
    case PartTypeSchema.enum.RECTANGULAR_TUBE:
      return "TUBE";
    default:
      return null;
  }
};

export const getMaterialLabelSuffix = ({ type }: Params) => {
  const key = getMaterialLabelSuffixKey(type);
  if (!key) {
    return "";
  }
  return t(`material.labelSuffix.${key}`);
};
